import React, { useEffect } from 'react'
import IndexEn from './components/PageEn/IndexEn'
import "./App.css"
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import IndexFa from './components/PageFa/IndexFa';
import ProductsFA from './components/PageFa/ProductsFA';
import ProductsEN from './components/PageEn/ProductsEN';

function App() {

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
      if (location.pathname === "/") {
          navigate("/en", { replace: true }); 
      }
  }, [location, navigate]);
  

  return (
    <Routes>
      <Route path='en' element={<IndexEn />}> 
        
      </Route>

      <Route>
        <Route path='fa' element={<IndexFa />} />
        <Route path='/fa/product' element={<ProductsFA />}/>
        <Route path='/en/product' element={<ProductsEN />}/>
      </Route>

    </Routes>
  )
}

export default App

// گروه تجارت پهلوان مقدم 